/* import __COLOCATED_TEMPLATE__ from './masked-input.hbs.js'; */
var _dec, _dec2, _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from "@glimmer/component";
import { action } from "@ember/object";
import { computed } from '@ember/object';
import { next } from '@ember/runloop';
import { ref } from 'ember-ref-bucket';
import InputMask from 'inputmask-core';
import { getSelection, setSelection } from '../util/selection';
const KEYCODE_Z = 90;
const KEYCODE_Y = 89;
const KEYCODE_BACKSPACE = 8;
function isUndo(e) {
  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
}
function isRedo(e) {
  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
}
const NOOP = function () {};
let MaskedInputComponent = (_dec = ref("inputEl"), _dec2 = computed('args.{mask,formatCharacters,placeholderChar}'), (_class = class MaskedInputComponent extends Component {
  constructor(...args) {
    super(...args);
    // Reference to the input element
    // inputEl = null;
    _initializerDefineProperty(this, "inputEl", _descriptor, this);
  }
  // Dunno why tracking a getter doesn't work here - needs explicit arg dependencies to update correctly.
  // Do not add value as dependency, since the input mask value will be set by the according actions.
  get inputMask() {
    const options = {
      pattern: this.args.mask || null,
      value: this.args.value,
      formatCharacters: this.args.formatCharacters || null
    };
    const placeholderChar = this.args.placeholderChar || '_';
    if (placeholderChar) {
      options.placeholderChar = placeholderChar;
    }
    return new InputMask(options);
  }
  get displayValue() {
    const value = this.inputMask.getValue();
    return value === this.inputMask.emptyValue ? '' : value;
  }
  get pattern() {
    return this.args.mask || '';
  }
  get size() {
    return this.pattern.length;
  }
  get maxlength() {
    return this.pattern.length;
  }
  get placeholder() {
    return this.inputMask.emptyValue;
  }
  get readonly() {
    return this.inputEl.readOnly;
  }
  get onChange() {
    return this.args['on-change'] || NOOP;
  }
  onInputChange(e) {
    const maskValue = this.inputMask.getValue();
    if (e.target.value !== maskValue) {
      // Cut or delete operations will have shortened the value
      if (e.target.value.length < maskValue.length) {
        const sizeDiff = maskValue.length - e.target.value.length;
        this.updateMaskSelection();
        this.inputMask.selection.end = this.inputMask.selection.start + sizeDiff;
        this.inputMask.backspace();
      }
      const value = this.displayValue;
      e.target.value = value;
      if (value) {
        this.updateInputSelection();
      }
    }
    this.onChange(e);
  }
  onInputKeyDown(e) {
    // On Firefox, ignore any key if input is readonly
    if (this.readonly) {
      return;
    }
    if (isUndo(e)) {
      e.preventDefault();
      if (this.inputMask.undo()) {
        e.target.value = this.displayValue;
        this.updateInputSelection();
        this.onChange(e);
      }
      return;
    } else if (isRedo(e)) {
      e.preventDefault();
      if (this.inputMask.redo()) {
        e.target.value = this.displayValue;
        this.updateInputSelection();
        this.onChange(e);
      }
      return;
    }
    if (e.keyCode === KEYCODE_BACKSPACE) {
      e.preventDefault();
      this.updateMaskSelection();
      if (this.inputMask.backspace()) {
        const value = this.displayValue;
        e.target.value = value;
        if (value) {
          this.updateInputSelection();
        }
        this.onChange(e);
      }
    }
  }
  onInputKeyPress(e) {
    // Ignore modified key presses
    // Ignore enter key to allow form submission
    // Ignore tab key to allow focussing other elements
    // On Firefox, ignore any key if input is readonly
    if (e.metaKey || e.altKey || e.ctrlKey || e.keyCode === 13 || e.keyCode === 9 || this.readonly) {
      return;
    }
    e.preventDefault();
    this.updateMaskSelection();
    const key = e.key || String.fromCharCode(e.charCode);
    if (this.inputMask.input(key)) {
      e.target.value = this.inputMask.getValue();
      this.updateInputSelection();
      this.onChange(e);
    }
  }
  onInputPaste(e) {
    // On Firefox, ignore paste if input is readonly
    if (this.readonly) {
      return;
    }
    e.preventDefault();
    this.updateMaskSelection();
    // getData value needed for IE also works in FF & Chrome
    const clipboardData = e.clipboardData || window.clipboardData;
    const text = clipboardData.getData('Text');
    const acceptsPaste = this.inputMask.paste(text);
    if (acceptsPaste) {
      e.target.value = this.inputMask.getValue();
      // Timeout needed for IE
      next(this, this.updateInputSelection);
      this.onChange(e);
    }
  }
  updateMaskSelection() {
    this.inputMask.selection = getSelection(this.inputEl);
  }
  updateInputSelection() {
    setSelection(this.inputEl, this.inputMask.selection);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "inputEl", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "inputMask", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "inputMask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputKeyPress", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputKeyPress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputPaste", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputPaste"), _class.prototype)), _class));
export { MaskedInputComponent as default };